import ArrowBackRounded from "@mui/icons-material/ArrowBackRounded";
import { Button, Paper, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Page } from "../../../common/components/Page";

export function NotFoundPage() {
  return (
    <Page>
      <Paper
        component="section"
        aria-label="Page not found"
        variant="outlined"
        sx={{ p: { xs: 3, sm: 5 }, textAlign: "center" }}
      >
        <Stack spacing={2} sx={{ alignItems: "center" }}>
          <Typography variant="overline" color="primary" aria-hidden>
            404
          </Typography>
          <Typography component="h1" variant="h4">
            We couldn&apos;t find that page
          </Typography>
          <Typography color="text.secondary">
            The link may be broken, or the page may have moved.
          </Typography>
          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            startIcon={<ArrowBackRounded />}
          >
            Back to Home
          </Button>
        </Stack>
      </Paper>
    </Page>
  );
}
